// F-17 (§0 taxonomy law): the user-facing book-type chip. There is NO product called a
// "gift book" — the customer-facing name is "Celebration". The internal flag stays
// bookType === 'GIFT' / isGiftBook; only the LABEL changes. One source of truth so the
// chip can't drift back to "Gift" on any surface it renders.
export function bookTypeChipLabel(bookType) {
  return bookType === 'PERSONAL' ? 'Personal' : 'Celebration';
}
